import React from "react";
import { useHistory } from "react-router-dom";
import SectionHead from "./SectionHead";
import "./HomeSections.css";

// Statik popüler arama önerileri — Header'daki /ara?kelime=X akışına yönlenir.
const TERMS = [
  "Kiralık Daire",
  "Satılık Daire",
  "Arsa",
  "Villa",
  "Müstakil Ev",
  "Otomobil",
  "Arazi SUV",
  "Motosiklet",
  "İş Yeri",
  "Yazlık",
];

function PopularSearches() {
  const history = useHistory();
  const go = (term) => history.push(`/ara?kelime=${encodeURIComponent(term)}`);

  return (
    <div className="hs-section container">
      <SectionHead
        title="Popüler Aramalar"
        subtitle="Herkesin aradığı kelimelerden ilham al"
        accent="#2D8CF0"
      />
      <div className="hs-chips">
        {TERMS.map((term) => (
          <button key={term} className="hs-chip" onClick={() => go(term)}>
            <i className="fa fa-search" />
            {term}
          </button>
        ))}
      </div>
    </div>
  );
}

export default PopularSearches;
